'use strict';

// Generated by `node bin/build-i18n.js` from config/i18n/**/*.json
module.exports = require('../../../config/i18n/index.json');
